import { FormLabel } from '@mui/material';
import React, { Fragment, useState } from 'react';
import CustomCheckBox from '../../Reusable/CustomCheckBox';

const CheckBoxDemo = () => {
  const [state, setState] = useState({
    altOption1: false,
    altOption2: false,
    altOptionAll: false,
  });

  const onCheckBoxChangeHandler = (event) => {
    const { name, checked } = event?.target || {};
    setState((prevState) => ({ ...prevState, [name]: checked }));
  };

  const onCheckBoxChangeHandlerReset = (event) => {
    const { name, checked } = event?.target || {};
    setState((prevState) => ({
      ...prevState,
      [name]: checked,
      altOption1: checked,
      altOption2: checked,
    }));
  };

  return (
    <Fragment>
      <div className="form-label-container">
        <FormLabel className="w-100">
          Odaberite jednu od ponudjenih opcija:
        </FormLabel>

        <CustomCheckBox
          name="altOptionAll"
          label={''}
          onChange={onCheckBoxChangeHandlerReset}
          checked={state.altOptionAll}
        />
      </div>

      <CustomCheckBox
        name="altOption1"
        label={'Opcija 1'}
        onChange={onCheckBoxChangeHandler}
        checked={state.altOption1}
      />
      <CustomCheckBox
        name="altOption2"
        label={'Opcija 2'}
        onChange={onCheckBoxChangeHandler}
        checked={state.altOption2}
      />
    </Fragment>
  );
};

export default CheckBoxDemo;
